import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Select2 from "@Shared/components/inputs/select2";
import { GET_SEGMENTS_TRANSLATION_MAP } from "@Broker/@Modules/marketing/store/marketing/marketing-getters";
import { mapGetters } from "vuex";
import { cloneDeep } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ConditionMultiOptionInput",
  components: {
    Select2
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    values: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    conditionName: {
      type: String,
      required: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    $v: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      open: false,
      maxCharactersToDisplay: 90
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("MarketingStore", [GET_SEGMENTS_TRANSLATION_MAP])), {}, {
    options() {
      return {
        closeOnSelect: false,
        dropdownCssClass: "condition-select-item"
      };
    },
    selectId() {
      return `multi-option-select-${this.index}`;
    },
    valuesLength() {
      return _valuesInstanceProperty(this).length;
    },
    valuesSelected() {
      const list = _Object$values(_valuesInstanceProperty(this));
      const values = [];
      let text = "";
      list.forEach(element => {
        const isCappedVariable = element.value === "capped-variable";
        if (this.conditionName === "Rate Type" && (isCappedVariable || element.value === "buy-down")) {
          text = isCappedVariable ? this.GET_SEGMENTS_TRANSLATION_MAP("capped_variable") : this.GET_SEGMENTS_TRANSLATION_MAP("buy_down");
        } else {
          var _this$GET_SEGMENTS_TR;
          text = (_this$GET_SEGMENTS_TR = this.GET_SEGMENTS_TRANSLATION_MAP(element.value)) != null ? _this$GET_SEGMENTS_TR : element.text;
        }
        values.push(" " + text);
      });
      return values.toString();
    },
    truncatedValuesSelected() {
      const truncated = this.$options.filters.truncateText(this.valuesSelected, this.maxCharactersToDisplay);
      return this.valuesSelected.length > this.maxCharactersToDisplay ? truncated : this.valuesSelected;
    }
  }),
  methods: {
    formatReferrerData(data) {
      data = cloneDeep(data);
      return data && _mapInstanceProperty(data).call(data, cond => ({
        id: cond.id,
        text: `${cond.givenName} ${cond.familyName}`
      }));
    },
    formatMultiOptionData(data) {
      data = cloneDeep(data);
      return data && _mapInstanceProperty(data).call(data, cond => _objectSpread(_objectSpread({}, cond), {}, {
        id: cond.id,
        text: this.GET_SEGMENTS_TRANSLATION_MAP(cond.label) || cond.label
      }));
    },
    multiSelectValuesIds() {
      var _context;
      return _mapInstanceProperty(_context = _valuesInstanceProperty(this)).call(_context, elem => elem.id);
    },
    handleOpen() {
      this.open = true;
      this.$nextTick(() => {
        this.$refs.select.open();
      });
    },
    handleClose() {
      this.open = false;
    },
    handleChange(data, type) {
      var _data$value, _data$text;
      const selectValue = {
        id: _parseInt(data.id),
        value: (_data$value = data.value) != null ? _data$value : data.text,
        text: (_data$text = data.text) != null ? _data$text : data.value
      };
      this.$emit("change", selectValue, type);
    }
  }
});